var map = {
	"./assets/audio/ArcadeWin.mp3": 35,
	"./assets/audio/Bells.mp3": 36,
	"./assets/audio/BigWin.mp3": 37,
	"./assets/audio/BonusWheel_MUSIC_END.mp3": 38,
	"./assets/audio/BonusWheel_MUSIC_LOOP.mp3": 39,
	"./assets/audio/GlitterAir.mp3": 40,
	"./assets/audio/Skeeballthrowroll.mp3": 41,
	"./assets/audio/ballHit1.mp3": 42,
	"./assets/audio/ballHopper.mp3": 43,
	"./assets/audio/balltrayFill.mp3": 44,
	"./assets/audio/beeda_loo.mp3": 45,
	"./assets/audio/blip.mp3": 46,
	"./assets/audio/clack1.mp3": 47,
	"./assets/audio/extraBall.mp3": 48,
	"./assets/audio/failSound.mp3": 49,
	"./assets/audio/fallinHole.mp3": 50,
	"./assets/audio/hit.mp3": 51,
	"./assets/audio/hit2.mp3": 52,
	"./assets/audio/inHole.mp3": 53,
	"./assets/audio/ramp.mp3": 54,
	"./assets/audio/ramp2.mp3": 55,
	"./assets/audio/rampRoll.mp3": 56,
	"./assets/audio/rolldown.mp3": 57,
	"./assets/audio/snare.mp3": 58,
	"./assets/audio/squirtle.mp3": 59,
	"./assets/audio/wav/hit3clang.mp3": 60
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;



//////////////////
// WEBPACK FOOTER
// ./app ./~/file-loader?name=audio/[name].mp3!^\.\/.*\.mp3$
// module id = 34
// module chunks = 0